import { render, staticRenderFns } from "./RegionCharts.vue?vue&type=template&id=5edacf0a&"
import script from "./RegionCharts.vue?vue&type=script&lang=js&"
export * from "./RegionCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports